import { createContext } from 'react'

import { JourneyData } from '@cash-web/shared-journey-util-main'

export const JourneyParentContext = createContext<JourneyData | undefined>(undefined)
